var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinancialAssets(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#financial-assets_svg__clip0_61530_7321)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.25 12h-1.5v1.5H18c-.825 0-1.5.675-1.5 1.5v1.5c0 .825.675 1.5 1.5 1.5h3v1.5h-4.5V21h2.25v1.5h1.5V21H21c.825 0 1.5-.675 1.5-1.5V18c0-.825-.675-1.5-1.5-1.5h-3V15h4.5v-1.5h-2.25V12zM21 6h-4.5V3c0-.825-.675-1.5-1.5-1.5H9c-.825 0-1.5.675-1.5 1.5v3H3c-.825 0-1.5.675-1.5 1.5V18c0 .825.675 1.5 1.5 1.5h11.25V18H3V7.5h18v3h1.5v-3c0-.825-.675-1.5-1.5-1.5zm-6 0H9V3h6v3z",
    fill: "#45464F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "financial-assets_svg__clip0_61530_7321"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgFinancialAssets;